/**
 * axios Plugin
 * axios config
 *
 * @since: 2017-11-23
 * @author: kdydesign.kim
 *
 * 2019.04.05 파일 다운로드 시 에러 났을 경우 return 하는 부분 추가 (res.config.returnErr 가 true 일 경우 데이터 리턴)
 */

// utils
// import {refreshTokenUtils} from '../utils/token'
import {i18n} from './i18n'
import https from 'https'
// import {base64Encode} from '~/utils/base64'
import { encryptionJsonString } from '~/utils/cryptoHelper'

// extend $file api
function extendAxios () {
  let method = arguments.length === 3 ? 'post' : 'get'

  return this[method].apply(this, arguments).then(res => {
    try {
      const contentDispos = res.headers['content-disposition'],
        headerFileInfo = contentDispos.split(';')[1].trim(),
        fileName = headerFileInfo.split('=')[1]

      return {
        data: res.data,
        fileName: decodeURIComponent(fileName) // TAMS
      }
    } catch (e) {
      try {
        if (res.config.responseType === 'arraybuffer') {
          const enc = new TextDecoder('utf-8'),
            arr = new Uint8Array(res.data),
            dec = enc.decode(arr),
            response = JSON.parse(dec)

          return {
            code: response.code,
            result: response.result
          }
        } else if (res.config.returnErr) {
          // 에러 데이터 관련 리턴
          return {
            code: 'nok',
            data: res.data
          }
        }
      } catch (err) {
        window.$nuxt.$log('[Error extendAxios]:', err)
      }
    }
  })
}

export default function ({$axios, redirect, route, store, app}) {
  $axios.setHeader('Cache-Control', 'no-cache')
  $axios.setHeader('Accept', 'application/json')

  // extend $file api
  _.assign($axios, {'$file': extendAxios})

  const agent = new https.Agent({
    rejectUnauthorized: false
  })

  // Request Interceptors
  $axios.onRequest(config => {
    // TAMS 제외 (사이드 이펙트 고려)
    // if (store.state.common.lockmode.isLock) {
    //   if (config.url.indexOf('current-time') === -1 &&
    //       config.url.indexOf('logout') === -1 &&
    //       config.url.indexOf('login') === -1) {
    //     throw new TypeError('LockScreen')
    //   }
    // }
    // TAMS
    if (store.state.common.common.preventLogoutAfterTimer) {
      store.state.common.common.components.loadingDialog.hide()
      throw new TypeError('TAMSSessionExpired')
    }

    const
      isLoading = _.has(config, 'loading') ? config.loading : true,
      isLoadingShow = _.has(config, 'loadingShow') ? config.loadingShow : true,
      loadingDialogComp = store.state.common.common.components.loadingDialog,
      ignoreHaPrefix = _.has(config, 'ignoreHaPrefix') ? config.ignoreHaPrefix : false, // TAMS
      isSecure = _.has(config, 'secure') ? config.secure : false // TAMS

    config.httpsAgent = agent

    if (loadingDialogComp && isLoading) {
      if (isLoadingShow) {
        loadingDialogComp.show({stopButton: false, message: 'Loading...'})
      }
    }

    // check GE/HA prefix
    const prefix = store.state.common.common.apiPrefix
    if (ignoreHaPrefix === false || prefix.startsWith('/GE:')) {
      if (prefix.length > 1 && config.url.startsWith('/api/')) {
        let resultPrefix = prefix
        if (ignoreHaPrefix) {
          const
            splitPrefix = prefix.split('/'),
            filterPrefix = splitPrefix.filter(chunk => !chunk.startsWith('ha:')) // ha prefix 만 제거

          resultPrefix = filterPrefix.join('/')
        }
        config.url = config.url.replace('/api/', `${resultPrefix}api/`)
      }
    }

    // TAMS
    if (isSecure) {
      if (config.method === 'get' && !_.isEmpty(config.params)) {
        // config.params = {
        //   secure_params: base64Encode(JSON.stringify(config.params))
        // }
      } else if (['put', 'post', 'delete'].indexOf(config.method) !== -1 && !_.isEmpty(config.data)) {
        let ecrypttext = ''
        if (typeof config.data === 'object' && config.data !== null) {
          let payload = {}
          _.each(Object.keys(config.data), key => {
            if (config.data[key]) {
              payload[key] = config.data[key]
            }
          })
          ecrypttext = encryptionJsonString(store.state.common.authenticate.encryptionAesKey, JSON.stringify(payload))
          config.data = {
            secure_params: ecrypttext
          }
        } else if (typeof config.data === 'string') {
          ecrypttext = encryptionJsonString(store.state.common.authenticate.encryptionAesKey, config.data)
          config.data = JSON.stringify({
            secure_params: ecrypttext
          })
        }
      }
    }
  })

  // Response Interceptors
  $axios.onResponse(response => {
    const
      config = response.config,
      isSuccessAlert = _.has(config, 'successAlert') ? config.successAlert : true,
      isAlertMsg = _.has(config, 'alertMsg'),
      isApplyMsg = _.has(config, 'applyMsg') ? config.applyMsg : false,
      isCancelMsg = _.has(config, 'cancelMsg') ? config.cancelMsg : false,
      isLoading = _.has(config, 'loading') ? config.loading : true,
      isLoadingHide = _.has(config, 'loadingHide') ? config.loadingHide : true,
      isNotAlert = _.has(config, 'isNotAlert') ? config.isNotAlert : false

    if (isNotAlert) return

    const loadingDialogComp = store.state.common.common.components.loadingDialog,
      alertDialogComp = store.state.common.common.components.alertDialog,
      reloginDialog = store.state.common.common.components.reloginDialog, // TAMS
      method = response.config.method,
      code = response.data.code

    let messageKey = ''

    if (alertDialogComp) {
      if (response.data.code === 'ok') {
        if (!isAlertMsg && !isApplyMsg && !isCancelMsg) {
          switch (method.toLowerCase()) {
            case 'post' :
              messageKey = 'msg.addApply'
              break
            case 'put' :
              messageKey = 'msg.updateApply'
              break
            case 'delete' :
              messageKey = 'msg.removeApply'
              break
            default:
              break
          }
        } else if (isApplyMsg && !isCancelMsg) {
          messageKey = i18n.t('msg.apply')
        } else if (isCancelMsg && !isApplyMsg) {
          messageKey = i18n.t('msg.cancelApply')
        } else {
          messageKey = response.config.alertMsg
        }

        if (isSuccessAlert) {
          if (method.toLowerCase() === 'post' ||
            method.toLowerCase() === 'put' ||
            method.toLowerCase() === 'delete') {
            alertDialogComp.show({
              message: messageKey,
              code: code
            })
          }
        }
      }
    }

    if (loadingDialogComp && isLoading) {
      if (isLoadingHide) {
        loadingDialogComp.hide()
      }
    }

    if (loadingDialogComp) {
      if (response.data.code !== 'ok' && response.data.code !== 'async') {
        loadingDialogComp.hide()
      }
    }

    // TAMS
    // 에러코드 팝업
    if (reloginDialog) {
      // if (response.data.code.substring(response.data.code.length - 2, response.data.code.length) === '31') {

      switch (code) {
        // You do not have permission for this request
        case '231':
          window.$nuxt.$log('You do not have permission for this request')
          // TODO: 개발상 임시 해제
          // reloginDialog.show('You do not have permission for this request')
          break

        case '232': // apiTokenDoesNotExist
        case '233': // apiTokenNotValid
        case '234': // apiTokenExpired
        case '235': // apiSessionExpired
          window.$nuxt.$log('Error :: Code', code)
          // TODO: 개발 임시 해제
          store.commit('common/lockmode/setIsLockMode', true)
          // store.commit('common/common/clearAgentTimeTimer')

          // 로그아웃 호출 (한번만 호출되도록)
          if (store.state.common.authenticate.alreadyRequestLogout === false) {
            store.commit('common/authenticate/setAlreadyRequestLogout')
            // 로그아웃 시 같은 세션 내 동일계정/다른계정 모두 로그아웃 됨. (호출 금지, 2022-01-19)
            // store.dispatch('common/authenticate/unloadLogout') // 세션 아웃 후 로그아웃
          }

          const reloginMsg = reloginDialog.$t('msg.reloginDialogMsg')
          reloginDialog.show(`${reloginMsg} (${code})`)

          // TAMS
          if (loadingDialogComp) {
            loadingDialogComp.hide()
          }
          break
      }
    }
  })

  // Error interceptors
  $axios.onError(error => {
    const isReturnError = _.has(error.config, 'isReturnError') ? error.config.isReturnError : false
    const isNotShowErrorAlert = _.has(error.config, 'isNotShowErrorAlert') ? error.config.isNotShowErrorAlert : false

    const
      reloginDialog = store.state.common.common.components.reloginDialog,
      alertDialogComp = store.state.common.common.components.alertDialog,
      loadingDialogComp = store.state.common.common.components.loadingDialog,
      duplicateConfirmDialog = store.state.common.common.components.duplicateConfirmDialog

    // TAMS
    // GUI 실행, external login 실패할 경우 메시지 예외 팝업
    const checkUrl = _.get(error, ['config', 'url'], '')
    if (checkUrl.indexOf('/api/au/external/login') !== -1) {
      alertDialogComp.show(`${i18n.t('msg.guiExecErrCertAuthorityInvalid')}\n${i18n.t('msg.guiExecErrCertAuthorityInvalid1')}`, 'error')
      return
    }
    const statusNumberString = error.response.status.toString()
    // healthCheckFailMsg`12`12`12`1
    if (!error.response || statusNumberString.startsWith('5')) {
      if (loadingDialogComp) {
        loadingDialogComp.hide()
      }
      if (error.response && error.response.status && error.response.statusText) {
        alertDialogComp.show(`${error.response.status} ${_.capitalize(error.response.statusText)}`, 'error')
      } else if (error.message !== 'LockScreen' && error.message !== 'TAMSSessionExpired') { // TAMS
        alertDialogComp.show(i18n.t('msg.notiMsgNetworkError', {msg: error.message}), 'error')
      }
      return
    }

    const
      errCode = error.response.status,
      errResultCode = _.get(error, ['error.response.data.code'], ''),
      resType = error.config.responseType

    if (loadingDialogComp) {
      loadingDialogComp.hide()
    }

    if (isReturnError) {
      return Promise.reject(error.response)
    }

    if (isNotShowErrorAlert) {
      return
    }

    // file 관련 에러처리
    if (resType === 'blob') {
      let errMsg = `${error.response.status} ${_.capitalize(error.response.statusText)}`

      if (_.has(error.config, 'errorMsg')) {
        errMsg = error.config.errorMsg
      }

      alertDialogComp.show(errMsg, 'error')
    }

    /* 토큰만료 / 세션타임아웃

    2018.09.04 김민수 : 토큰 만료 시 다이얼로그 출력. 다이얼로그에서 확인버튼 클릭 시 로그인 페이지로 이동
    - 12002: 객체 이름 중복
    - 12003: predefine 객체 제거 실패
    - 12004: 객체 삭제 불가능
    - 15003: 객체 내용 중복
    - 15006: 객체 그룹 내용 중복
    - 15007: 도메인 객체 이름 내용 중복
    - 15010: force 옵션으로 삭제 가능
    - 15012: 서비스 객체 내용 중복
    - 15011: 그룹 멤버가 1만 남아서 삭제 불가능
    - 17003: 애플리케이션 그룹 객체 중복
    - 94011: API 토큰없이 REST API 요청
    - 94013: API 토큰 만료.
    - 94014: 재로그인 필요.
    - 94016: 토큰을 발급한 장비의 정보가 변경된 경우
    */
    if (errCode === 400) {
      const resCode = Number(errResultCode)
      // 객체 내용 중복
      if ([15003, 15006, 15007, 15012, 17003].indexOf(resCode) >= 0) {
        return new Promise((resolve, reject) => {
          duplicateConfirmDialog.show({msg: error.response.data.message})
            .then((isRetry) => {
              if (isRetry) {
                let configData = JSON.parse(error.config.data)
                configData.force = 1
                error.config.data = configData
                if (error.config.baseURL !== '/' && error.config.url.indexOf(error.config.baseURL) !== -1) {
                  error.config.url = error.config.url.replace(error.config.baseURL, '/')
                }
                $axios.request(error.config).then((res) => {
                  resolve(res)
                })
              } else {
                reject(new Error(error.response.data.msg))
              }
            })
        })
      } else {
        // alertDialogComp.show(error.response.data, 'error')
        alertDialogComp.show(`${error.response.status} ${error.response.statusText}`, 'error')
      }
    } else if (errCode === 401) {
      const resCode = Number(errResultCode)
      // API 토큰없이 REST API 요청
      if (resCode === 94011) {
        // expired
        // refresh token
        // refreshTokenUtils(store) // TAMS 제외
      } else if (resCode === 94013 || resCode === 94014 || resCode === 94016) {
        // 토큰 또는 세션이 만료되어 재로그인이 필요한 경우
        const reloginMsg = reloginDialog.$t('msg.reloginDialogMsg')
        reloginDialog.show(reloginMsg)
      } else {
        // alertDialogComp.show(error.response.data, 'error')
        alertDialogComp.show(`${error.response.status} ${error.response.statusText}`, 'error') // TAMS
      }
    } else {
      // alertDialogComp.show(error.response.data, 'error')
      alertDialogComp.show(`${error.response.status} ${error.response.statusText}`, 'error') // TAMS
    }
  })
}
